
const services = [
  {
    name: 'Отель',
    service: 'hotels',
    module: 'accommodations'
  },
  {
    name: 'Мед.страховка',
    service: 'insurances',
    module: 'insurances'
  },
  {
    name: 'Трансфер',
    service: 'transfers',
    module: 'transfers'
  },
  {
    name: 'Авиа',
    service: 'flights',
    module: 'aviatickets'
  },
  {
    name: 'Экскурсии',
    service: 'excursions',
    module: 'excursions'
  },
  {
    name: 'Виза',
    service: 'visas',
    module: 'visas'
  },
]

export default services